import { render, staticRenderFns } from "./IndividualBankDetails.vue?vue&type=template&id=6c64083f"
import script from "./IndividualBankDetails.vue?vue&type=script&lang=js"
export * from "./IndividualBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports